(function () {
  if (window.stellaColBindCarousels) return;

  function syncDots(car) {
    var img = car.parentElement;
    if (!img) return;
    var i = Math.round(car.scrollLeft / Math.max(car.clientWidth, 1));
    if (car.scrollLeft > 2) img.classList.add('is-scrolled');
    var dots = img.querySelector('.stellaCol__dots');
    if (!dots) return;
    var items = dots.children;
    for (var n = 0; n < items.length; n++) {
      items[n].classList.toggle('is-active', n === i);
    }
  }

  function preloadCarouselImgs(car) {
    car.querySelectorAll('.stellaCol__slide img:not(.stellaCol__hoverImg)').forEach(function (img, idx) {
      if (idx > 2) return;
      if (img.complete && img.naturalWidth > 0) return;
      var url = img.currentSrc || img.src;
      if (!url) return;
      var p = new Image();
      p.decoding = 'async';
      p.src = url;
      if (idx > 0) img.loading = 'eager';
    });
  }

  function bind(car) {
    if (car.dataset.stellaDotsBound) return;
    car.dataset.stellaDotsBound = '1';
    preloadCarouselImgs(car);
    var ticking = false;
      car.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        syncDots(car);
        preloadCarouselImgs(car);
      });
    }, { passive: true });

    var hoverSync = function () {
      var img = car.parentElement;
      if (!img || img.classList.contains('is-scrolled')) return;
      if (!img.querySelector('.stellaCol__hoverImg')) return;
      if (!window.matchMedia('(hover: hover)').matches) return;
      var card = img.closest('.stellaCol__card');
      if (!card || !card.matches(':hover')) return;
      if (car.scrollLeft > 2) return;
      car.scrollLeft = car.clientWidth;
      img.classList.add('is-scrolled');
      syncDots(car);
    };

    var kill = function () {
      var img = car.parentElement;
      if (img && car.scrollLeft > 0) img.classList.add('is-scrolled');
    };
    car.addEventListener('touchstart', kill, { passive: true });
    car.addEventListener('pointerdown', kill, { passive: true });
    car.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        hoverSync();
        var img = car.parentElement;
        if (img) img.classList.add('is-scrolled');
      }
    }, { passive: true });
  }

  window.stellaColBindCarousels = function (scope) {
    var s = scope || document;
    s.querySelectorAll('[data-stella-carousel]').forEach(bind);
    s.querySelectorAll('.stellaCol__hoverImg').forEach(function (img) {
      if (img.classList.contains('is-loaded')) return;
      if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  };

  window.stellaColBindCarousels(document);
  document.addEventListener('shopify:section:load', function (e) {
    window.stellaColBindCarousels(e.target || document);
  });
})();
